import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
  field: {
    wordBreak: 'break-word',
    marginBottom: 0
  }
});

export default makeStyles(styles);
